import { createStructuredSelector } from "reselect";
import {
    VDR_DATA_USER,
    VDR_DATA_USER_SUCCESS,
    VDR_DATA_USER_ERROR,
    VDR_DOCUMENT_TYPE,
    VDR_DOCUMENT_TYPE_SUCCESS,
    VDR_DOCUMENT_TYPE_ERROR,
    VDR_DELIVERY_ORDER,
    VDR_DELIVERY_ORDER_SUCCESS,
    VDR_DELIVERY_ORDER_ERROR,
    VDR_SUPPLIER,
    VDR_SUPPLIER_SUCCESS,
    VDR_SUPPLIER_ERROR,
    VDR_EQUIPMENT,
    VDR_EQUIPMENT_SUCCESS,
    VDR_EQUIPMENT_ERROR,
    VDR_SERIAL,
    VDR_SERIAL_SUCCESS,
    VDR_SERIAL_ERROR,
    VDR_STATUS_REVIEW,
    VDR_STATUS_REVIEW_SUCCESS,
    VDR_STATUS_REVIEW_ERROR,
    VDR_USER_REVIEW,
    VDR_USER_REVIEW_SUCCESS,
    VDR_USER_REVIEW_ERROR,
    VDR_STATUS_DOCS,
    VDR_STATUS_DOCS_SUCCESS,
    VDR_STATUS_DOCS_ERROR,
    VDR_UNIT_HEALTH,
    VDR_UNIT_HEALTH_SUCCESS,
    VDR_UNIT_HEALTH_ERROR,
    VDR_LIST,
    VDR_LIST_SUCCESS,
    VDR_LIST_ERROR,
    VDR_LIST_SEARCH_CHANGE,
    VDR_LIST_PAGE_SET,
    VDR_VALIDATE_MODAL_SET,
    VDR_VALIDATE_CHANGE_SET,
    VDR_VALIDATE,
    VDR_VALIDATE_SUCCESS,
    VDR_VALIDATE_ERROR,
    VDR_CHECKLIST_VALIDATION,
    VDR_CHECKLIST_VALIDATION_SUCCESS,
    VDR_CHECKLIST_VALIDATION_ERROR,
    VDR_SEE_VALIDATE_MODAL_SET,
    VDR_SEE_VALIDATE_CHANGE_SET,
    VDR_SEE_VALIDATE,
    VDR_SEE_VALIDATE_SUCCESS,
    VDR_SEE_VALIDATE_ERROR
} from "../../actions";

export const NAME = 'validationDocumentReview';

export const VDRDataUser = (data) => ({
    type: VDR_DATA_USER,
    payload: data
});

export const VDRDataUserSuccess = (data) => ({
    type: VDR_DATA_USER_SUCCESS,
    payload: data
});

export const VDRDataUserError = (error) => ({
    type: VDR_DATA_USER_ERROR,
    payload: error
});

export const VDRDocumentType = (data) => ({
    type: VDR_DOCUMENT_TYPE,
    payload: data
});

export const VDRDocumentTypeSuccess = (data) => ({
    type: VDR_DOCUMENT_TYPE_SUCCESS,
    payload: data
});

export const VDRDocumentTypeError = (error) => ({
    type: VDR_DOCUMENT_TYPE_ERROR,
    payload: error
});

export const VDRDeliveryOrder = (data) => ({
    type: VDR_DELIVERY_ORDER,
    payload: data
});

export const VDRDeliveryOrderSuccess = (data) => ({
    type: VDR_DELIVERY_ORDER_SUCCESS,
    payload: data
});

export const VDRDeliveryOrderError = (error) => ({
    type: VDR_DELIVERY_ORDER_ERROR,
    payload: error
});

export const VDRSupplier = (data) => ({
    type: VDR_SUPPLIER,
    payload: data
});

export const VDRSupplierSuccess = (data) => ({
    type: VDR_SUPPLIER_SUCCESS,
    payload: data
});

export const VDRSupplierError = (error) => ({
    type: VDR_SUPPLIER_ERROR,
    payload: error
});

export const VDREquipment = (data) => ({
    type: VDR_EQUIPMENT,
    payload: data
});

export const VDREquipmentSuccess = (data) => ({
    type: VDR_EQUIPMENT_SUCCESS,
    payload: data
});

export const VDREquipmentError = (error) => ({
    type: VDR_EQUIPMENT_ERROR,
    payload: error
});

export const VDRSerial = (data) => ({
    type: VDR_SERIAL,
    payload: data
});

export const VDRSerialSuccess = (data) => ({
    type: VDR_SERIAL_SUCCESS,
    payload: data
});

export const VDRSerialError = (error) => ({
    type: VDR_SERIAL_ERROR,
    payload: error
});

export const VDRStatusReview = (data) => ({
    type: VDR_STATUS_REVIEW,
    payload: data
});

export const VDRStatusReviewSuccess = (data) => ({
    type: VDR_STATUS_REVIEW_SUCCESS,
    payload: data
});

export const VDRStatusReviewError = (error) => ({
    type: VDR_STATUS_REVIEW_ERROR,
    payload: error
});

export const VDRUserReview = (data) => ({
    type: VDR_USER_REVIEW,
    payload: data
});

export const VDRUserReviewSuccess = (data) => ({
    type: VDR_USER_REVIEW_SUCCESS,
    payload: data
});

export const VDRUserReviewError = (error) => ({
    type: VDR_USER_REVIEW_ERROR,
    payload: error
});

export const VDRStatusDocs = (data) => ({
    type: VDR_STATUS_DOCS,
    payload: data
});

export const VDRStatusDocsSuccess = (data) => ({
    type: VDR_STATUS_DOCS_SUCCESS,
    payload: data
});

export const VDRStatusDocsError = (error) => ({
    type: VDR_STATUS_DOCS_ERROR,
    payload: error
});

export const VDRUnitHealth = (data) => ({
    type: VDR_UNIT_HEALTH,
    payload: data
});

export const VDRUnitHealthSuccess = (data) => ({
    type: VDR_UNIT_HEALTH_SUCCESS,
    payload: data
});

export const VDRUnitHealthError = (error) => ({
    type: VDR_UNIT_HEALTH_ERROR,
    payload: error
});

export const VDRList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: VDR_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const VDRListSuccess = (data) => ({
    type: VDR_LIST_SUCCESS,
    payload: data
});

export const VDRListError = (error) => ({
    type: VDR_LIST_ERROR,
    payload: error
});

export const VDRListSearchChange = (data) => ({
    type: VDR_LIST_SEARCH_CHANGE,
    payload: data
});

export const VDRListPageSet = (data) => ({
    type: VDR_LIST_PAGE_SET,
    payload: data
});


export const VDRValidateModalSet = (data) => ({
    type: VDR_VALIDATE_MODAL_SET,
    payload: data
});

export const VDRValidateChangeSet = (data) => ({
    type: VDR_VALIDATE_CHANGE_SET,
    payload: data
});

export const VDRValidate = (page, num_page, orderBy, filters, data) => ({
    type: VDR_VALIDATE,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const VDRValidateSuccess = (message) => ({
    type: VDR_VALIDATE_SUCCESS,
    payload: message
});

export const VDRValidateError = (error) => ({
    type: VDR_VALIDATE_ERROR,
    payload: error
});

export const VDRChecklistValidation = (data) => ({
    type: VDR_CHECKLIST_VALIDATION,
    payload: data
});

export const VDRChecklistValidationSuccess = (data) => ({
    type: VDR_CHECKLIST_VALIDATION_SUCCESS,
    payload: data
});

export const VDRChecklistValidationError = (error) => ({
    type: VDR_CHECKLIST_VALIDATION_ERROR,
    payload: error
});


export const VDRSeeValidateModalSet = (data) => ({
    type: VDR_SEE_VALIDATE_MODAL_SET,
    payload: data
});

export const VDRSeeValidateChangeSet = (data) => ({
    type: VDR_SEE_VALIDATE_CHANGE_SET,
    payload: data
});

export const VDRSeeValidate = (data) => ({
    type: VDR_SEE_VALIDATE,
    payload: data
});

export const VDRSeeValidateSuccess = (message) => ({
    type: VDR_SEE_VALIDATE_SUCCESS,
    payload: message
});

export const VDRSeeValidateError = (error) => ({
    type: VDR_SEE_VALIDATE_ERROR,
    payload: error
});


const validationDocumentReview = (state) => state[NAME];

export const ValidationDocumentReviewSelector = createStructuredSelector({
    validationDocumentReview
})
